<template>
  <BCard
    class="border"
    :style="{
      backgroundColor: currentKey === 0 ? '#cbedff' : (
        // key === 1 ? '#d8f8c3' : '#cbedff'
        // key === 1 ? '#d8f8c3' : '#white'
        '#eee'
      )
    }"
  >
    <div class="pb-1 mb-3 border-bottom">
      <span class="font-weight-bold text-muted">
        Events for {{ dateMonthShortFormatter(eventDay) }} ( <b :class="currentKey === 0 ? 'text-primary' : ''">{{ weekFormatter(eventDay) }}</b> )
      </span>
    </div>
    <BRow class="gap-y-3 px-2">
      <BCol
        v-for="event in events[eventDay]"
        :key="event.id"
        cols="12"
        md="4"
        class="px-1"
      >
        <BCard
          class="border"
          body-class="p-2"
        >
          <div class="d-flex align-items-center gap-2 px-2">
            <BAvatar
              :text="String(event.new_number_of_activities)"
              variant="outline-dark"
              size="36"
            />

            <div class="d-flex flex-column px-md-2">
              <h6
                :class="[
                  'font-weight-bolder text-truncate mb-1'
                ]"
              >
                {{ event.activity?.activity_name }}
              </h6>
              <div class="d-flex gap-2">
                <div
                  v-if="event.province"
                  class="small text-dark"
                >
                  To be held at <b>
                    {{ event.province?.province_name || '' }}, {{ event.municipality?.municipality_name || '' }}
                  </b>
                </div>
              </div>
            </div>
          </div>
        </BCard>
      </BCol>
    </BRow>
  </BCard>
</template>
<script>
import formatter from '@/mixins/formatter'

export default {
  name: 'FSODashboardUpcomingEvent',

  mixins: [
    formatter
  ],

  props: {
    currentKey: {
      type: Number,
      required: true
    },
    eventDay: {
      type: String,
      required: true
    },

    events: {
      type: Object,
      required: true
    }
  }
}
</script>
